import {
    Box,
    Heading,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
} from '@ksyos/design-system';
import type { DeclarationWithActivitiesAndBatch } from '@frontend/components/pages/processes/AdminProcessDetailsFinancialStatus';
import { NullableFormattedDate } from '@frontend/components/elements/NullableFormattedDate';
import { getSelectedLanguage } from '@frontend/translate';

type FinanceDeclarationsProps = {
    declarationsRecords?: DeclarationWithActivitiesAndBatch[];
    label: string;
};

export function FinanceDeclarations({
    declarationsRecords: declarationRecords,
    label,
}: FinanceDeclarationsProps): JSX.Element | null {
    if (!declarationRecords || declarationRecords.length === 0) {
        return null;
    }

    const translate = getSelectedLanguage();

    return (
        <Box marginBottom={3}>
            <Heading
                as="h3"
                fontWeight="bold"
                marginBottom={1}
                size="small"
            >
                {label}
            </Heading>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableHeader>{translate.finance.activityCode}</TableHeader>
                            <TableHeader>{translate.finance.declarationDate}</TableHeader>
                            <TableHeader>{translate.patient.insurancePolicyNumberShort}</TableHeader>
                            <TableHeader>{translate.finance.counterBooking}</TableHeader>
                            <TableHeader>{translate.export.runDate}</TableHeader>
                            <TableHeader>{translate.export.runNumber}</TableHeader>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {declarationRecords.map((declaration) => {
                            const policyNumber = declaration.insurancePolicyNumber || '';

                            return declaration.activities.map((activity) => {
                                return (
                                    <TableRow key={activity.id}>
                                        <TableCell>{activity.activityCode}</TableCell>
                                        <TableCell>
                                            <NullableFormattedDate value={activity.activityDate} />
                                        </TableCell>
                                        <TableCell>{policyNumber}</TableCell>
                                        <TableCell>{declaration.counterBookedDeclarationId ? 'TB' : ''}</TableCell>
                                        <TableCell>
                                            <NullableFormattedDate value={declaration.exportBatch?.runDate} />
                                        </TableCell>
                                        <TableCell>{declaration.exportBatch?.runNumber}</TableCell>
                                    </TableRow>
                                );
                            });
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}
